import { registerComponent } from '../app'
import { OPEN_CART, CLOSE_CART } from '../events'

const SideCart = (scope, el) => {
	const props = {
		openClass: 'open'
	}

	scope.on(OPEN_CART, () => {
		el.classList.add(props.openClass)
	})

	scope.on(CLOSE_CART, () => {
		el.classList.remove(props.openClass)
	})
}

registerComponent('side-cart', SideCart)
